import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row g-6 overflow-auto" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body pt-8 pb-5 pe-3 ps-3" }
const _hoisted_4 = { class: "d-md-flex justify-content-between pb-4 border-bottom" }
const _hoisted_5 = { class: "d-flex flex-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "/media/logos/logo_sens.svg",
  style: {"width":"30px"}
}, null, -1)
const _hoisted_7 = { class: "card-label fs-1 fw-bolder m-1 text-dark px-2" }
const _hoisted_8 = { class: "fs-4 text-muted fw-light" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn bg-white text-blue ms-2 border-start",
  "data-bs-toggle": "modal",
  "data-bs-target": "#historialModal"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "/media/icons/histo-icon.svg",
    style: {"width":"20px","height":"21px"}
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-md-inline d-none" }, " Historial ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bell fs-3 text-blue" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "d-md-inline d-none" }, " Crear Alerta ", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("button", { class: "btn bg-white text-blue ms-2 border-start" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "/media/icons/informe-icon.svg",
    style: {"width":"21px","height":"16px"}
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-md-inline d-none" }, " Nuevo Informe ")
], -1)
const _hoisted_14 = { class: "row g-6 g-lg-10 py-6 border-bottom" }
const _hoisted_15 = { class: "pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalCalibracion = _resolveComponent("ModalCalibracion")!
  const _component_ModalNotifiacion = _resolveComponent("ModalNotifiacion")!
  const _component_ModalHistorial = _resolveComponent("ModalHistorial")!
  const _component_CardTemperatura = _resolveComponent("CardTemperatura")!
  const _component_DispositivoGrafica = _resolveComponent("DispositivoGrafica")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("h3", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.dispositivo.nombre), 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.dispositivo.sedeNombre) + " / " + _toDisplayString(_ctx.dispositivo.areaNombre), 1)
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_9,
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.modalNotifiacion.toggle())),
              class: "btn bg-white text-blue border-start"
            }, _hoisted_12),
            _hoisted_13,
            _createVNode(_component_ModalCalibracion, {
              ref: "modalCalibracion",
              datosDispo: _ctx.dispositivo
            }, null, 8, ["datosDispo"]),
            _createVNode(_component_ModalNotifiacion, {
              datosDispo: _ctx.dispositivo,
              ref: "modalNotifiacion"
            }, null, 8, ["datosDispo"]),
            _createVNode(_component_ModalHistorial, { ref: "modalHistorial" }, null, 512)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dispositivo.sensores, (data, key) => {
            return (_openBlock(), _createBlock(_component_CardTemperatura, {
              key: key,
              llave: key,
              dato: data,
              dispositivo: _ctx.dispositivo,
              cardFocus: _ctx.cardFocus[key],
              fecha_custom: _ctx.fechaCustomCard,
              onResponseSuccess: _ctx.setDataSensor,
              onOpenModalCalibracion: _ctx.openCalibracion
            }, null, 8, ["llave", "dato", "dispositivo", "cardFocus", "fecha_custom", "onResponseSuccess", "onOpenModalCalibracion"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_DispositivoGrafica, {
            datos: _ctx.dispositivo,
            ref: "dispoGrafica",
            onChangeFocusedCard: _ctx.changeFocusedCard,
            onChangeFechaCustom: _ctx.refreshDataCards
          }, null, 8, ["datos", "onChangeFocusedCard", "onChangeFechaCustom"])
        ])
      ])
    ])
  ]))
}